import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { ReactChild, useState } from "react";
import { Carousel } from "react-responsive-carousel";

import APSpeedoLoader from "./APSpeedoLoader";

type APCarouselProps = {
  children: ReactChild[];
  navigationType?: "speedo" | "headerArrows";
  hideArrows?: boolean;
  autoPlay?: boolean;
};

const APCarousel = ({
  children,
  navigationType = "speedo",
  hideArrows = false,
  autoPlay = false,
}: APCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentSpeedoStart, setCurrentSpeedoStart] = useState(Date.now());

  const handleChange = (index: number) => {
    setCurrentIndex(index);
    setCurrentSpeedoStart(Date.now());
  };

  const changeIndex = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  const renderLeftArrow = (icon: React.ReactNode) => {
    return (
      <IconButton
        color="inherit"
        size="small"
        sx={{ visibility: "visible" }}
        onClick={() => handleChange(currentIndex - 1)}
      >
        {icon}
      </IconButton>
    );
  };

  const renderRightArrow = (icon: React.ReactNode) => {
    return (
      <IconButton
        color="inherit"
        size="small"
        sx={{ visibility: "visible" }}
        onClick={() => handleChange(currentIndex + 1)}
      >
        {icon}
      </IconButton>
    );
  };

  return (
    <Box sx={{ position: "relative" }}>
      {navigationType === "headerArrows" && (
        <Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
          {renderLeftArrow(<KeyboardArrowLeftOutlinedIcon />)}
          {renderRightArrow(<KeyboardArrowRightOutlinedIcon />)}
        </Box>
      )}
      <Carousel
        selectedItem={currentIndex}
        onChange={handleChange}
        showThumbs={false}
        showIndicators={false}
        showArrows={!hideArrows}
        showStatus={false}
        infiniteLoop
        interval={6000}
        autoPlay={autoPlay}
      >
        {children}
      </Carousel>
      {children.length > 1 && navigationType === "speedo" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            mx: 4,
            mt: 1,
          }}
        >
          <Box>{renderLeftArrow(<ArrowLeftIcon />)}</Box>
          <Box sx={{ mx: 0.5 }}>
            <APSpeedoLoader
              handleChange={changeIndex}
              startTime={currentSpeedoStart}
              duration={6000}
            />
          </Box>
          <Box>{renderRightArrow(<ArrowRightIcon />)}</Box>
        </Box>
      )}
    </Box>
  );
};

export default APCarousel;
